<template>
    <div class="setting">
        <div class="setting-top">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="page-content">
            <div class="box">
                <div class="box-content ">
                    <h2>系统设置</h2>
                    <h3>个人信息管理</h3>
                   <div class="info  ">
                       <p style="margin-bottom: 20px">修改个人的基础信息，包括个人头像、昵称、登录账号、修改密码等</p>
                       <el-button @click="toEdit">立即修改</el-button>
                   </div>
                    <div class="p-set" v-if="role==1">
                        <h3 style="margin-top: 20px;">分成比例设置</h3>
                        <el-button @click="toSetting">立即设置</el-button>
                    </div>
                    <div class="p-set" v-if="role==1">
                        <h3 style="margin-top: 20px;">平台安全手机号设置</h3>
                        <el-button @click="dialogFormVisible = true">立即设置</el-button>
                    </div>
                </div>
            </div>

            <el-dialog title="平台安全手机号设置" :visible.sync="dialogFormVisible">
                <el-form :model="form"  align="left" :rules="rules">
                    <el-form-item label="当前平台安全手机号" label-width="150px" v-if="curMobile">
                        <el-input v-model="curMobile" :disabled="true" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="平台安全手机号" label-width="150px" prop="mobile">
                        <el-input v-model="form.mobile" autocomplete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="toSetPhone">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {getRoleMobile,setRoleMobile} from '../../api/index'
    export default {
        name: "setting",
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('手机号码不能为空'));
                }
                setTimeout(() => {
                    if (!/^[1][0-9]{10}$/.test(value)) {
                        callback(new Error('请输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 500);
            };
            return{
                role:0,
                dialogFormVisible:false,
                curMobile:'',
                form:{
                    mobile:'',
                },
                rules:{
                    mobile:[
                        { required: true, message: '请输入管理员手机号', trigger: 'blur' },
                        { validator: checkPhone, trigger: 'blur' }
                    ]
                }
            }
        },
        created(){
          this.role=localStorage.getItem('ROLE') ;
          this.getMobile();
        },
        methods:{
            getMobile(){
                getRoleMobile().then(res=>{
                    if(res.code==1){
                        this.curMobile=res.data.value;
                    }
                })
            },
            toEdit(){
                this.$router.push({path:'./edit'});
            },
            toSetting(){
                this.$router.push({path:'/withdraw/setting'})
            },
            toSetPhone(){
                if(!/^[1][0-9]{10}$/.test(this.form.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                setRoleMobile(this.form).then(res=>{
                    if(res.code==1){
                        this.$message.success('操作成功');
                        this.dialogFormVisible=false;
                        this.getMobile();
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.setting-top{
    padding: 20px 0 0 20px;
}
.page-content{
    padding: 20px;
    .box{
        background-color: #fff;
        padding: 20px;
        text-align: left;
        .box-content{
            width: 100%;
            h2{
                font-size: 24px;
                padding-bottom: 10px;
            }
            h3{
                font-size: 18px;
                color: #333;
                padding-bottom: 20px;
            }
            .info{
                color: #666666;
                width: 100%;
            }
        }
    }
}
</style>
